<template>
  <div class="general-container">
    <the-navbar
      :centered="true"
      :return-link="returnLink"
    />
    <heatmap-detailed v-if="!loading" />
  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue'
import HeatmapDetailed from '@/components/project-dashboard/heatmap/HeatmapDetailed.vue'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ActivityDashboard',
  components: {
    TheNavbar,
    HeatmapDetailed
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters('Projects', ['isCommunityProject']),
    ...mapState('Projects', ['projectData']),
    returnLink() {
      if (this.projectData) {
        return {
          title: this.projectData.name,
          link: {
            name: 'activity-dashboard',
            params: {
              identifier: this.projectData.identifier
            }
          }
        }
      }

      return null
    }
  },
  async created() {
    const fetchParams = this.$route.params

    await Promise.all([
      this.$store.dispatch(
        'Projects/getProjectData',
        { projectIdentifier: fetchParams.projectIdentifier, edit: false }
      ),
      this.$store.dispatch('summary/getActivity', fetchParams)
    ])

    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
.general-container {
  margin-bottom: 0px;
}
</style>

<style lang="scss" scoped>
  @import '@/scss/project_dashboard.scss';
</style>

<style lang="scss" scoped>
  @import '../scss/activity_summary.scss';
</style>
